import event from 'wolfy87-eventemitter'
import { observable, action, autorun, configure, runInAction, when, reaction } from 'mobx'

export default class BaseMapStore{
    @observable currentBaseMap = 'OSM'
    @action 
    changeBaseMap(val) {
        console.log(val);
        this.currentBaseMap = val
    }
    getCurrentBaseMap(){
        return this.currentBaseMap
    }
    // setBaseMap(e){
    //     this.emit('setBaseMap',e)
    // } 
}
